import {put, takeEvery} from "redux-saga/effects";
import {SkuGender} from "../../../Models/SkuGender";
import {localStorage} from "../../../lib/storages/localStorage";
import {skuGendersGetError, skuGendersGetSuccess} from "./actions";
import * as TYPES from "./types";

export default function* skuGendersSagas() {
    yield takeEvery(TYPES.SKU_GENDERS_GET_REQUEST, skuGendersGetRequest);
}

function* skuGendersGetRequest(action) {
    try {
        let items = [];

        if (localStorage.getItem(TYPES.SKU_GENDERS_GET_REQUEST)) {
            items = localStorage.getItem(TYPES.SKU_GENDERS_GET_REQUEST);
        } else {
            const response = yield SkuGender.index({
                ...action.payload,
            });

            items = response.data.items;
            localStorage.setItem(TYPES.SKU_GENDERS_GET_REQUEST, items);
        }

        const data = {
            items: items,
            pagination: {total: 0, pages: 0},
        };

        yield put(
            skuGendersGetSuccess({
                data,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(skuGendersGetError(error));
    }
}
